import { makeStyles } from "@mui/styles";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import FullscreenVirtualizedGrid from "./FullscreenVirtualizedGrid";
import { resetCurrentSelectedItems, setSelectMode } from "../../../store/actions";

const useStyles = makeStyles({
  gridContainer: {
    margin: "12px",
    paddingLeft: (props) => (props.leftDrawer ? "240px" : "0px"),
    paddingRight: (props) => (props.rightDrawer ? "240px" : "0px"),
    height: "100vh",
  },
});

export default function FullscreenGridView(props) {
  const {
    filteredMediaItems,
    propertyId,
    experienceId,
    addNewExperience,
    leftDrawer,
    rightDrawer,
    leftDrawerAutoHide,
    rightDrawerAutoHide,
    experienceMediaItems,
    params,
    locked,
  } = props;

  const classes = useStyles({
    ...props,
    leftDrawer: leftDrawer && !leftDrawerAutoHide,
    rightDrawer: rightDrawer && !rightDrawerAutoHide,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetCurrentSelectedItems());
    dispatch(setSelectMode(true));
  }, []);

  if (filteredMediaItems.length === 0) return "";

  return (
    <div className={classes.gridContainer}>
      <FullscreenVirtualizedGrid
        list={filteredMediaItems}
        minWidth={180}
        minHeightGrow={1.2}
        selectModeEnabled={filteredMediaItems.length}
        propertyId={propertyId}
        experienceId={experienceId}
        addNewExperience={addNewExperience}
        experienceMediaItems={experienceMediaItems}
        params={params}
        locked={locked}
      />
    </div>
  );
}
